<template>
	<div id="template">
		<div class="web-view-container">
			<div>
				<b-button-group class="lang-buttons">
					<b-button class="mr-1" variant="info" v-for="locale in languages" :key="locale.title" @click="changeLocale(locale.language)">
						<img v-bind:src="locale.flag" height="30px" v-bind:alt="locale.title">
					</b-button>
				</b-button-group>
			</div>
				<h1 class="webview-elem-margin" style="color:#004f9e;">{{ $t(content.title) }}</h1>
			<div class="user-infos">
				<b-form @submit="onSubmit" @reset="onReset">

					<label>{{ $t('form_labels.soussigne') }}</label>
					<b-form-input id="nameInput"
						class="webview-elem-margin webview-input"
						type="text"
						v-model="form_content.name"
						required
						v-bind:placeholder="$t('form_placeholders.soussigne')">
					</b-form-input>

					<label>{{ $t('form_labels.birthdate') }}</label>
					<b-form-input id="birthInput"
						class="webview-elem-margin webview-input"
						type="date"
						v-model="form_content.birthdate"
						required>
					</b-form-input>

					<label>{{ $t('form_labels.address') }}</label>
					<b-form-input id="addressInput"
						class="webview-elem-margin webview-input"
						type="text"
						v-model="form_content.address"
						required
						v-bind:placeholder="$t('form_placeholders.address')">
					</b-form-input>

					<label>{{ $t('form_labels.minor') }}</label>
					<b-form-input id="minorInput"
						class="webview-elem-margin webview-input"
						type="text"
						v-model="form_content.minor"
						v-bind:placeholder="$t('form_placeholders.minor')">
					</b-form-input>
					<div class="agreement-description-container webview-elem-margin">

						<label>{{ $t('form_labels.subject') }}</label>
						<b-form-input id="subjectInput"
							class="webview-elem-margin webview-input"
							type="text"
							v-model="form_content.subject"
							required
							v-bind:placeholder="$t('form_placeholders.subject')">
						</b-form-input>

						<label>{{ $t('form_labels.thematic') }}</label>
						<b-form-input id="thematic"
							class="webview-elem-margin webview-input"
							type="text"
							v-model="form_content.thematic"
							required
							v-bind:placeholder="$t('form_placeholders.thematic')">
						</b-form-input>

						<p>{{ $t(content.agreement_description.p01) }}</p>

						<h2>{{ $t(content.agreement_description.t1) }}</h2>
						<p>{{ $t(content.agreement_description.p11) }}</p>

						<p>{{ $t(content.agreement_description.p12) }}</p>

						<h2>{{ $t(content.agreement_description.t2) }}</h2>
						<p>{{ $t(content.agreement_description.p21) }}</p>
						<p>{{ $t(content.agreement_description.p22) }}</p>

						<h2>{{ $t(content.agreement_description.t3) }}</h2>
						<p>{{ $t(content.agreement_description.p31) }}</p>
						<p>{{ $t(content.agreement_description.p32) }}</p>

						<h2>{{ $t(content.agreement_description.t4) }}</h2>
						<p>{{ $t(content.agreement_description.p41) }}</p>

						<h2>{{ $t(content.agreement_description.t5) }}</h2>
						<p>{{ $t(content.agreement_description.p51) }}</p>

						<h2>{{ $t(content.agreement_description.t6) }}</h2>
						<p>{{ $t(content.agreement_description.p61) }}</p>

						<h2>{{ $t(content.agreement_description.t7) }}</h2>
						<p>{{ $t(content.agreement_description.p71) }}</p>

						<h2>{{ $t(content.agreement_description.t8) }}</h2>
						<p>{{ $t(content.agreement_description.p81) }}</p>
						<p>{{ $t(content.agreement_description.p82) }}</p>

						<label>{{ $t('form_labels.place') }}</label>
						<b-form-input id="placeInput"
							class="webview-elem-margin webview-input"
							type="text"
							v-model="form_content.place"
							required
							v-bind:placeholder="$t('form_placeholders.place')">
						</b-form-input>

						<label>{{ $t('form_labels.filming') }}</label>
						<b-form-input id="dateInput"
							class="webview-elem-margin webview-input"
							type="date"
							v-model="form_content.filming_date"
							required>
						</b-form-input>
						<label>{{ $t('form_labels.email_address') }}</label>
            <b-form-input id="mailAddressInput"
                          class="webview-elem-margin webview-input"
                          type="email"
                          :state="mailAddressValidity"
                          v-model="form_content.email_address"
                          required
                          v-bind:placeholder="$t('form_placeholders.email_address')">
            </b-form-input>
            <label>{{ $t('form_labels.referent_email_address') }}</label>
            <b-form-input id="referentMailAddressInput"
                          class="webview-elem-margin webview-input"
                          type="email"
                          :state="referentMailAddressValidity"
                          v-model="form_content.referent_email_address"
                          required
                          v-bind:placeholder="$t('form_placeholders.referent_email_address')">
            </b-form-input>
						<p>{{ $t("form.mail_notice") }}</p>
					</div>

					<b-button
						class="webview-elem-small-margin form-button btn-reset"
						type="reset" variant="outline-danger"
					>{{ $t('form_logic.reset_button') }}
          </b-button>

					<b-button class="webview-elem-small-margin form-button btn-valid" type="submit" :disabled="buttonActivation">
						<div class="submit-content" v-if="form_logic.submitStep === 'Initial'">{{ $t('form_logic.submit_button') }}</div>
						<b-spinner small v-if="form_logic.submitStep === 'Submitting'" />
						<svg class="submission-icon" v-if="form_logic.submitStep === 'Error'">
							<path d="M 13 0.261719 C 5.964844 0.261719 0.261719 5.964844 0.261719 13 C 0.261719 20.035156 5.964844 25.738281 13 25.738281 C 20.035156 25.738281 25.738281 20.035156 25.738281 13 C 25.738281 5.964844 20.035156 0.261719 13 0.261719 Z M 18.996094 17.761719 C 19.308594 18.070312 19.316406 18.570312 19.007812 18.890625 C 18.699219 19.203125 18.199219 19.207031 17.878906 18.902344 L 13 14.117188 L 8.117188 18.898438 C 7.800781 19.207031 7.296875 19.199219 6.988281 18.882812 C 6.679688 18.570312 6.683594 18.066406 7 17.753906 L 11.859375 12.996094 L 7.003906 8.238281 C 6.691406 7.929688 6.683594 7.429688 6.992188 7.109375 C 7.300781 6.796875 7.800781 6.792969 8.121094 7.097656 L 13.003906 11.882812 L 17.886719 7.101562 C 18.199219 6.792969 18.703125 6.796875 19.015625 7.113281 C 19.324219 7.429688 19.316406 7.933594 19 8.242188 L 14.136719 13 Z M 18.996094 17.761719 "></path>
						</svg>
					</b-button>
          <b-button class="webview-elem-small-margin form-button btn-cancel"
                    id="button-back"
                    @click="goBack()">
            {{ $t('form_logic.back_button') }}
          </b-button>
          <b-button class="webview-elem-small-margin form-button btn-info"
                    @click.prevent="exportAgreement()">
            {{ $t('form_logic.print_button') }}
          </b-button>
				</b-form>
			</div>
		</div>
	</div>
</template>

<script>
import Navbar from "@/components/ui/Navbar";
import axios from "axios";

export default {
	components: {Navbar},
	name: "ImageRightsAgreement",
	data() {
		return {
			languages: [
				{ flag: "static/images/flags/fr.svg", language: "fr", title: "Français" },
				{ flag: "static/images/flags/en.svg", language: "en", title: "English" },
			],
			usermail: sessionStorage.getItem("usermail"),
			content: {
				navbarName: "test titre",
				title: "form.title",
				agreement_description: {
					"t0": "form.agreement_description.t0",
					"p01": "form.agreement_description.p01",

					"t1": "form.agreement_description.t1",
					"p11": "form.agreement_description.p11",
					"p12": "form.agreement_description.p12",

					"t2": "form.agreement_description.t2",
					"p21": "form.agreement_description.p21",
					"p22": "form.agreement_description.p22",

					"t3": "form.agreement_description.t3",
					"p31": "form.agreement_description.p31",
					"p32": "form.agreement_description.p32",

					"t4": "form.agreement_description.t4",
					"p41": "form.agreement_description.p41",

					"t5": "form.agreement_description.t5",
					"p51": "form.agreement_description.p51",

					"t6": "form.agreement_description.t6",
					"p61": "form.agreement_description.p61",

					"t7": "form.agreement_description.t7",
					"p71": "form.agreement_description.p71",

					"t8": "form.agreement_description.t8",
					"p81": "form.agreement_description.p81",
					"p82": "form.agreement_description.p82",
				},
				company_name: "Horoquartz",
				company_contact_address: "contact@enjoyb.fr",
			},
			// form_content contains all the signatory user input data
			form_content: {
				name: "",
				capacity: "",
				birthdate: new Date().toISOString().split("T")[0],
				address: "",
				minor: "",
				email_address: "",
				referent_email_address: sessionStorage.getItem("usermail"),
				filming_date: new Date().toISOString().split("T")[0],
				place: "",
				thematic: "",
				subject: "",
			},
			// form_logic is used to manage the form comportment
			form_logic: {
				// submitStep manages which symbol is displayed on the input button. It has four possible values : notSubmitted / Submitting / Submitted / Error
				submitStep: "Initial",
				// Manages if the button is enabled or disabled
				buttonState: "enabled",
			},
			// Used to check if the email address is an acceptable one
			mailRegex: new RegExp("^[a-zA-Z0-9.!#$%&’*+\\/=?^_`{|}~-]+@[a-zA-Z0-9-]+\\.(fr|com|org|net|us|co|int|mil|edu|gov|biz|info|jobs|mobi|name|ly|tel|email|tech|xyz|ca|cn|ch|au|in|de|be|nl|uk|no|ru|es|se)$"),
		};
	},
	created() {
		if (this.$route.query.company_name) {
			let $this = this;
			axios.get("https://api.enjoyb.fr/agreements/?company_name=" + this.$route.query.company_name + "&referent_email_address=" + this.usermail)
			.then(function (response) {
				// Javascript weak typing at its finest: $this.$route.query.id changes type depending on how we access
				// the view, directly or from a previous view.
				// noinspection EqualityComparisonWithCoercionJS
				let data = response.data.records.filter(record => record.id == $this.$route.query.id);
				if (data.length > 0) {
					$this.form_content = data[0];
				}
			});
		}
	},
	methods: {
		changeLocale(locale) {
			this.$i18n.locale = locale;
		},
		buildAgreement() {
			let translatedAgreementDescription = {};
			for (let element in this.content.agreement_description) {
				translatedAgreementDescription[element] = this.$t(this.content.agreement_description[element]);
			}
			return translatedAgreementDescription;
		},
		onSubmit(evt) {
			evt.preventDefault();
			if (confirm(this.$t("interactions.submit_confirmation"))) {
				this.form_logic.buttonState = "disabled";
				this.form_logic.submitStep = "Submitting";
				this.sendMessage();
			}
		},
		onReset(evt) {
			this.form_content.filming_date = new Date().toISOString().split("T")[0];
			// The following line is necessary because VueJS keeps the old values on reset.
			this.form_content.name = "";
			this.form_content.email_address = "";
			this.form_content.referent_email_address = "";
			this.form_content.capacity = "";
			this.form_content.place = "";
			this.form_content.thematic = "";
			this.form_content.address = "";
			this.form_content.minor = "";
			this.form_content.subject = "";
			this.form_logic.submitStep = "Initial";
			this.form_logic.buttonState = "enabled";
		},
		sendMessage() {
			let message = {
				"name": this.form_content.name,
				"birthdate": this.form_content.birthdate,
				"address": this.form_content.address,
				"minor": this.form_content.minor,
				"capacity": this.form_content.capacity,
				"email_address": this.form_content.email_address,
				"referent_email_address": this.form_content.referent_email_address,
				"place": this.form_content.place,
				"thematic": this.form_content.thematic,
				"subject": this.form_content.subject,
				"company_name": this.content.company_name,
				"company_contact": this.content.company_contact_address,
				"language": this.$i18n.locale,
				"filming_date": this.form_content.filming_date,
				"agreement_description": this.buildAgreement(),
			};

			let propValue;
			for (let propName in message) {
				propValue = message[propName];
			}

			axios // Makes the API call to the mail platform
			.post("https://api.enjoyb.fr/agreements/", message)
			.then(response => (this.treatAnswer(response)))
			// eslint-disable-next-line
				.catch(error => {
				this.form_logic.submitStep = "Error";
				alert(this.$t("interactions.submit_error"));
			});
		},
		treatAnswer(response) {
			switch (response.data.result) {
			case "AlreadyExists":
				alert(this.$t("interactions.already_exists"));
				break;
			case "ServerError":
				this.form_logic.submitStep = "Error";
				alert(this.$t("interactions.server_error"));
				break;
			case "Success":
				alert(this.$t("interactions.success"));
				break;
			default:
				this.form_logic.submitStep = "Error";
				alert(this.$t("interactions.unknown_error"));
				break;
			}
			this.form_logic.submitStep = "Initial";
			this.onReset();
			window.scrollTo(0, 0);
		},
		goBack() {
			this.$router.push({name: "Dashboard"});
		},
		exportAgreement() {
			window.print();
		},
	},
	computed: {
		// Check the validity of the email address with a Regex
		mailAddressValidity: function () {
			if (this.mailRegex.exec(this.form_content.email_address)) {
				return true;
			} else if (this.form_content.email_address === "") {
				return undefined;
			}
			return false;
		},
		referentMailAddressValidity: function () {
			if (this.mailRegex.exec(this.form_content.referent_email_address)) {
				return true;
			} else if (this.form_content.referent_email_address === "") {
				return undefined;
			}
			return false;
		},
		// Binds the button activation state with the variable
		buttonActivation: function () {
			if (this.form_logic.buttonState === "disabled") {
				return true;
			}
			return false;
		},
		getCompanyName: function () {
			if (typeof this.companyName !== "undefined") {
				return this.companyName;
			}
			return "unknown app";
		},
	},
};
</script>

<style scoped>
	h1 {
		text-align: center;
		font-size: 2rem;
	}

	h2 {
		font-size: 1.2rem;
		font-weight:bold;
	}

	.web-view-container {
		margin-left: 10%; margin-right: 10%;
	}
	.webview-elem-margin {
		margin: 0 auto 2rem;
	}

	.agreement-description-container p {
		margin: 0 0 20px;
	}

  .webview-elem-small-margin {
    margin: 1rem auto;
  }
  .webview-input {
    max-width: 326px;
  }
  .form-button {
    margin-right: 1rem;
    width: 120px;
    height: 40px;
  }
  .submission-icon {
    height: 26px; width: 26px;
    margin: auto;
    fill: white;
  }
	.lang-buttons {
		position: fixed;
		right: 0;
		bottom: 0;
		margin:5px;
	}
	.btn {
		padding: 0;
		border-radius: 0;
    }
  .btn-info {
    border-radius: 0;
    background-color: #27509B;
    border-color: #27509B;
    font-weight: bold;
  }
  .btn-info:hover {
    border-radius: 0;
    background-color: #53565A;
    border-color: #53565A;
    color: white;
    font-weight: bold;
  }
  .btn-valid {
    border-radius: 0;
    background-color: #FCE500;
    border-color: #FCE500;
    color: black;
    font-weight: bold;
  }
  .btn-valid:hover {
    border-radius: 0;
    background-color: #53565A;
    border-color: #53565A;
    color: white;
    font-weight: bold;
  }
  .btn-reset:hover {
    border-radius: 0;
    background-color: #53565A;
    border-color: #53565A;
    color: white;
    font-weight: bold;
  }

  @media only screen and (min-device-width: 720px) {
    .web-view-container {
      margin-left: 25%;
      margin-right: 25%;
    }
    .webview-input {
      max-width: 326px;
      margin-left: 0;
    }
    .form-button {
      margin-right: 3.5rem;
    }
  }
  @media only screen and (min-width : 720px) {
    #button-back {
      border-radius: 0;
      background-color: #f4f4f4;
      border-color: #f4f4f4;
      color: black;
      font-weight: bold;
    }
    #button-back:hover {
      border-radius: 0;
      background-color: #53565A;
      border-color: #53565A;
      color: white;
      font-weight: bold;
    }
  }

  @media only screen and (max-width : 719px) {
    #button-back {
      display: none;
    }
  }

</style>
